import { SimpleGrid } from '@chakra-ui/react';
import { categories } from '../data';
import CategoryItem from './CategoryItem';

const Categories = () => {
  return (
    <SimpleGrid columns={[1, 1, 3, 3]} spacing="10" py="40px">
      {categories.map(item => (
        <CategoryItem item={item} key={item.id} />
      ))}
    </SimpleGrid>
  );
};

export default Categories;
